import {
  ICreateSaleLineItem,
  IInitPaymentLinkTransactionRequest,
  IViewPaymentLinkLineItem,
} from "../../interfaces-and-types";

import imagePlaceholder from "../../assets/icons/img-placeholder.svg";
import { formatAsCurrency, truncateStringWithEllipsis } from "../../utils";
import { CurrencyDisplay } from "../../components";
import { TextInput } from "../../hook-form";
import {
  DeepRequired,
  FieldErrorsImpl,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { useCheckoutPage } from "../../hooks";

export const SaleLineItemQuantityEditor = (props: {
  isInputDisabled: boolean;
  index: number;
  paymentLinkLineItem: IViewPaymentLinkLineItem;
  saleLineItem: ICreateSaleLineItem;
  setValue: UseFormSetValue<IInitPaymentLinkTransactionRequest>;
  register: UseFormRegister<IInitPaymentLinkTransactionRequest>;
  errors: FieldErrorsImpl<DeepRequired<IInitPaymentLinkTransactionRequest>>;
}) => {
  const {
    isInputDisabled,
    setValue,

    register,
    errors,
    index,
    paymentLinkLineItem,
    saleLineItem,
  } = props;

  const { checkoutItemsLocked, searchLineItemsText } = useCheckoutPage();

  const showPricePerUnit = saleLineItem.qty > 1; // || saleLineItem.qty === 0;

  const isInSearch =
    !searchLineItemsText ||
    paymentLinkLineItem.product_name
      .toLowerCase()
      .includes(searchLineItemsText);

  const qtyEditorDisabled =
    !paymentLinkLineItem.is_qty_adjustable_by_customer ||
    isInputDisabled ||
    checkoutItemsLocked;

  const itemNotSelected = saleLineItem.qty <= 0;

  // hide while/after making payment/displaying success page if qty is 0
  if (isInputDisabled && itemNotSelected) return null;

  // hide if not in search
  if (!isInSearch) return null;

  return (
    <div className="hosted-payment-link--container flex-container bb">
      <div className="product-logo--container">
        <img
          src={paymentLinkLineItem.product_icon ?? imagePlaceholder}
          alt="product icon"
          className="payment-link--product-icon"
        />
      </div>

      <div className="flex-box">
        <div className="flex-container col">
          <div className="flex-container">
            <div className="flex-box mr-5">
              <span title={paymentLinkLineItem.product_name}>
                {truncateStringWithEllipsis(
                  paymentLinkLineItem.product_name,
                  20
                )}
              </span>
            </div>

            <div className="line-item--total">
              <CurrencyDisplay
                currencyOrSymbol={paymentLinkLineItem.currency}
                amount={saleLineItem.qty * paymentLinkLineItem.price}
                amountFontSize={14}
              />
            </div>
          </div>

          <div className="flex-container pricing-detail--row switchapp-small">
            <div className="flex-box flex-container no-wrap align-items--center mr-5">
              Qty{qtyEditorDisabled ? ":" : " "}
              {qtyEditorDisabled ? (
                <span className="font-ctm--bold">&nbsp;{saleLineItem.qty}</span>
              ) : (
                <>
                  <button
                    className="checkout-qty--button remove-button ml-5"
                    onClick={() =>
                      setValue(
                        `line_items.${index}.qty`,
                        1 * saleLineItem.qty - 1
                      )
                    }
                    disabled={isInputDisabled || saleLineItem.qty <= 0}
                  >
                    ‒ {/* NOTE: this is character U+2012, NOT a minus sign */}
                  </button>

                  <div>
                    <TextInput
                      name={`line_items.${index}.qty`}
                      className="sale-line-item--input"
                      label=""
                      type="text"
                      register={register}
                      errors={errors}
                      disabled={isInputDisabled}
                    />
                  </div>

                  <button
                    className="checkout-qty--button add-button"
                    onClick={() =>
                      setValue(
                        `line_items.${index}.qty`,
                        1 * saleLineItem.qty + 1
                      )
                    }
                    disabled={
                      isInputDisabled ||
                      saleLineItem.qty >= paymentLinkLineItem.max_qty
                    }
                  >
                    +
                  </button>
                </>
              )}
            </div>

            {showPricePerUnit ? (
              <div className="">
                {paymentLinkLineItem.currency}{" "}
                {formatAsCurrency(paymentLinkLineItem.price)} each
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
